export enum SkillType {
  FRONTEND = "FRONTEND",
  BACKEND = "BACKEND",
  DEVOPS_TOOLS = "DEVOPS_TOOLS",
}

export interface AdminSkill {
  id: string | number;
  name: string;
  iconClass: string;
  iconColor: string;
  type: SkillType;
}

export interface ProjectImage {
  id: string | number;
  url: string;
}

export interface AdminProject {
  id: string | number;
  name: string;
  descriptionPt: string;
  descriptionEn: string;
  techStack: string[];
  viewUrl: string;
  codeUrl: string;
  images: ProjectImage[];
}

export interface AdminWorkHistory {
  id: string | number;
  company: string;
  rolePt: string;
  roleEn: string;
  descriptionPt: string;
  descriptionEn: string;
  startDate: string;
  endDate: string | null;
}

export interface AdminContact {
  id: string | number;
  platform: string;
  url: string;
  iconClass: string;
  label: string;
}

export interface AdminCertificate {
  id: string | number;
  name: string;
  descriptionPt: string;
  descriptionEn: string;
  issuerName: string;
  issueDate: string;
  expirationDate: string | null;
  credentialId: string;
  credentialUrl: string;
  fileUrl: string | null;
  issuerLogoUrl: string | null;
  displayOrder: number | null;
}

export interface CreateCertificateRequest {
  name: string;
  descriptionPt: string;
  descriptionEn: string;
  issuerName: string;
  issueDate: string;
  expirationDate: string | null;
  credentialId: string;
  credentialUrl: string;
  displayOrder: number | null;
}

export interface UpdateCertificateRequest {
  name: string;
  descriptionPt: string;
  descriptionEn: string;
  issuerName: string;
  issueDate: string;
  expirationDate: string | null;
  credentialId: string;
  credentialUrl: string;
  displayOrder: number | null;
}

export interface AdminAboutBio {
  pt: string;
  en: string;
}

export interface AdminTranslations {
  pt: Record<string, unknown>;
  en: Record<string, unknown>;
}

export interface AuthState {
  isAuthenticated: boolean;
  token: string | null;
}

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface RegisterCredentials {
  email: string;
  password: string;
}

export interface ApiResponse<T> {
  success: boolean;
  data?: T;
  message?: string | null;
}

export interface PaginationParams {
  pageNumber?: number;
  pageSize?: number;
}

export interface CreateSkillRequest {
  name: string;
  iconClass: string;
  iconColor: string;
  type: string;
}

export interface UpdateSkillRequest {
  name: string;
  iconClass: string;
  iconColor: string;
  type: string;
}

export interface CreateProjectRequest {
  name: string;
  descriptionPt: string;
  descriptionEn: string;
  techStack: string[];
  viewUrl: string;
  codeUrl: string;
}

export interface UpdateProjectRequest {
  name: string;
  descriptionPt: string;
  descriptionEn: string;
  techStack: string[];
  viewUrl: string;
  codeUrl: string;
}

export interface CreateWorkHistoryRequest {
  company: string;
  rolePt: string;
  roleEn: string;
  descriptionPt: string;
  descriptionEn: string;
  startDate: string;
  endDate: string | null;
}

export interface UpdateWorkHistoryRequest {
  company: string;
  rolePt: string;
  roleEn: string;
  descriptionPt: string;
  descriptionEn: string;
  startDate: string;
  endDate: string | null;
}

export interface CreateContactRequest {
  platform: string;
  url: string;
  iconClass: string;
  label: string;
}

export interface UpdateContactRequest {
  platform: string;
  url: string;
  iconClass: string;
  label: string;
}

export interface TrackVisitRequest {
  pageVisited: string;
  referer: string | null;
}

export interface TrackVisitResponse {
  tracked: boolean;
  message?: string | null;
}

export interface CountryVisitsDto {
  country: string | null;
  countryCode: string | null;
  count: number;
}

export interface CityVisitsDto {
  city: string | null;
  country: string | null;
  count: number;
}

export interface BrowserVisitsDto {
  browser: string | null;
  count: number;
}

export interface OsVisitsDto {
  operatingSystem: string | null;
  count: number;
}

export interface DeviceVisitsDto {
  device: string | null;
  count: number;
}

export interface DailyVisitsDto {
  date: string;
  count: number;
}

export interface HourlyVisitsDto {
  hour: number;
  count: number;
}

export interface IpVisitsDto {
  ipAddress: string | null;
  city: string | null;
  country: string | null;
  count: number;
}

export interface DashboardStatsResponse {
  totalVisits: number;
  todayVisits: number;
  thisWeekVisits: number;
  thisMonthVisits: number;
  uniqueVisitors: number;
  visitsByCountry: CountryVisitsDto[] | null;
  visitsByCity: CityVisitsDto[] | null;
  visitsByBrowser: BrowserVisitsDto[] | null;
  visitsByOs: OsVisitsDto[] | null;
  visitsByDevice: DeviceVisitsDto[] | null;
  visitsPerDay: DailyVisitsDto[] | null;
  visitsByHour: HourlyVisitsDto[] | null;
  visitsByIp: IpVisitsDto[] | null;
}
